import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/next/font/google/target.css?{\"path\":\"src/app/(main)/curso-graduacao-ead/[cursoId]/page.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"mont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2403834457/src/faculdademetropolitana/src/components/PanelGridDocente.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2403834457/src/faculdademetropolitana/src/components/PulseButton.tsx");
